import { render, staticRenderFns } from "./QuestionScale.vue?vue&type=template&id=362588f8&scoped=true&"
import script from "./QuestionScale.vue?vue&type=script&lang=js&"
export * from "./QuestionScale.vue?vue&type=script&lang=js&"
import style0 from "./QuestionScale.vue?vue&type=style&index=0&id=362588f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362588f8",
  null
  
)

export default component.exports